import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    max-width: 400px;
    margin: auto;

    .information {
        margin-bottom: 2em;
        font-size: 14px;

        .span {
            font-weight: bold;
        }
    }

    .layout-forms-input {
        &:first-of-type {
            margin-bottom: 2em;
        }
        
        &.name-phonePrefix {
            max-width: 6em;
        }

        .label-wrapper {
            .label-body {
                .layout-forms-input-label {
                    opacity: 1;
                    color: black;
                    transform: translate(0.6em, -0.1em);
                    font-size: 1.2em;
                    font-weight: 400;
                }
            }
        }

        .input-body {
            .input {
                border: 2px solid #BA9449;
                color: #BA9449;
                font-size: 1.2em;
                padding: 0.6em 0.8em;
                height: 3.2em;

                &::placeholder {
                    color: #BA9449;
                    opacity: 0.4;
                }
            }
        }
    }

    .inputs-additions {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 1em 0.6em;

        .password-reset {
            width: 100%;
            justify-content: flex-end;
            padding-top: .3em;

            .button {
                &:hover {
                    .button-content {
                        font-weight: unset;
                    }
                }
            }
        }
    }

    .form-control {
        &.layout-button {
            .button {
                font-size: 1.4em;
                padding: 0.8em;
            }
        }
    }

    .form-footer {
        padding: 1.4em;
        max-width: 380px;
        margin: auto;
        font-size: .75em;
        text-align: center;

        .footer-link {
            color: #BA9449;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    @media all and (max-width: ${vars.tabletL}) {
        padding: 0.4em 0;
    }
`;
